export const downloadFromUrl = (url, filename) => {
  const u = String(url || "").trim();
  if (
    !u ||
    u === "-" ||
    u.toLowerCase() === "null" ||
    u.toLowerCase() === "undefined"
  )
    return false;
  const a = document.createElement("a");
  a.href = u;
  a.target = "_blank";
  a.rel = "noopener,noreferrer";
  a.download = String(filename || "download");
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  return true;
};

export const downloadBlob = (data, filename, mime) => {
  if (!data) return false;
  const blob = data instanceof Blob ? data : new Blob([data], { type: mime || "application/octet-stream" });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = String(filename || "download");
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => window.URL.revokeObjectURL(url), 60000);
  return true;
};
